module.exports = __webpack_public_path__ + "static/media/Oxygen-Regular.d5ea9b25.ttf";